import { BaseApiService } from '@/shared/api/services/base.service';
import { buildUrl } from '@/shared/lib/query-params';
import type {
  TokenPackagesResponse,
  TokenBalanceResponse,
  TokenPurchaseResponse,
  TokenPurchasesResponse,
} from '@/types/tokens';

class TokensService extends BaseApiService {
  async getPackages(): Promise<TokenPackagesResponse> {
    return this.httpGet<TokenPackagesResponse>('/v1/tokens/packages');
  }

  async getBalance(): Promise<TokenBalanceResponse> {
    return this.httpGet<TokenBalanceResponse>('/v1/tokens/balance');
  }

  async getPurchaseHistory(params?: {
    page?: number;
    per_page?: number;
  }): Promise<TokenPurchasesResponse> {
    const url = buildUrl('/v1/tokens', {
      page: params?.page ? { number: params.page } : undefined,
      per_page: params?.per_page,
    });
    return this.httpGet<TokenPurchasesResponse>(url);
  }

  async getPurchase(purchaseId: string): Promise<TokenPurchaseResponse> {
    return this.httpGet<TokenPurchaseResponse>(`/v1/tokens/${purchaseId}`);
  }

}

export const tokensService = new TokensService();
